import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=7286a428&scoped=true"
var script = {}
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=7286a428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7286a428",
  null
  
)

export default component.exports